// Bridges Dawn's cart pubsub to Northbound's headless cart mutation event.
// Loaded globally so ATC, card steppers, quick-add, cart page, and drawer
// updates all trigger the same Northbound cart repricing path.

(function () {
  if (window.__arcticNorthboundCartBridgeReady) return;
  window.__arcticNorthboundCartBridgeReady = true;

  var SNAPSHOT_SELECTOR = '[data-arctic-northbound-cart-snapshot]';
  var REAL_CART_SELECTOR = '[data-northbound-cart]:not([data-arctic-northbound-cart-snapshot])';

  function bind() {
    if (
      typeof subscribe !== 'function' ||
      typeof PUB_SUB_EVENTS === 'undefined' ||
      !PUB_SUB_EVENTS.cartUpdate
    ) {
      return;
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      handleCartUpdate(event);
    });
  }

  function handleCartUpdate(event) {
    var source = event && event.source;
    var realCart = document.querySelector(REAL_CART_SELECTOR);

    if (!realCart) {
      syncSnapshotCart(event)
        .then(function (cartData) {
          dispatchCartChanged(event, cartData, 'snapshot');
        })
        .catch(function () {
          dispatchCartChanged(event, event && event.cartData, 'snapshot-error');
        });
      return;
    }

    if (source === 'cart-items') {
      dispatchCartChanged(event, event && event.cartData, 'cart-items');
      return;
    }

    // External card/product ATC can publish before Dawn finishes re-rendering
    // cart-items/cart-drawer-items. Let the owning cart element dispatch after
    // its replacement, then send one delayed fallback for nonstandard paths.
    window.setTimeout(function () {
      dispatchCartChanged(event, event && event.cartData, 'rendered-fallback');
    }, 500);
  }

  function dispatchCartChanged(event, cartData, phase) {
    window.dispatchEvent(
      new CustomEvent('northbound:cart-changed', {
        detail: {
          source: event && event.source,
          cartData: cartData || (event && event.cartData),
          variantId: event && (event.variantId || event.productVariantId),
          phase: phase,
        },
      })
    );
  }

  function syncSnapshotCart(event) {
    var cartData = event && event.cartData;
    if (cartData && Array.isArray(cartData.items)) {
      renderSnapshotCart(cartData);
      return Promise.resolve(cartData);
    }

    return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        renderSnapshotCart(data);
        return data;
      });
  }

  function renderSnapshotCart(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return;
    if (document.querySelector(REAL_CART_SELECTOR)) {
      removeSnapshotCart();
      return;
    }

    var snapshot = document.querySelector(SNAPSHOT_SELECTOR);
    if (!snapshot) {
      snapshot = document.createElement('div');
      snapshot.hidden = true;
      snapshot.setAttribute('data-northbound-cart', '');
      snapshot.setAttribute('data-arctic-northbound-cart-snapshot', '');
      document.body.appendChild(snapshot);
    }

    var subtotalCents = Number(cartData.total_price);
    if (!Number.isFinite(subtotalCents)) {
      subtotalCents = cartData.items.reduce(function (sum, item) {
        return sum + toCents(item && item.final_line_price);
      }, 0);
    }

    removeSnapshotArtifacts();
    snapshot.innerHTML = '';
    cartData.items.forEach(function (item) {
      var variantId = item && (item.variant_id || item.id);
      var quantity = Number(item && item.quantity);
      if (!variantId || !Number.isFinite(quantity) || quantity <= 0) return;

      var line = document.createElement('div');
      line.setAttribute('data-northbound-cart-line', '');
      line.setAttribute('data-northbound-variant-id', String(variantId));
      line.setAttribute('data-northbound-base-line-cents', String(toCents(item.final_line_price)));

      var input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-northbound-cart-quantity', '');
      input.value = String(quantity);

      var total = document.createElement('span');
      total.setAttribute('data-northbound-cart-line-total', '');

      line.append(input, total);
      snapshot.appendChild(line);
    });

    var productsTotal = document.createElement('span');
    productsTotal.setAttribute('data-northbound-cart-products-total', '');
    productsTotal.setAttribute('data-northbound-base-subtotal-cents', String(toCents(subtotalCents)));

    var shippingTotal = document.createElement('span');
    shippingTotal.setAttribute('data-northbound-cart-shipping-total', '');

    var packagingFeeTotal = document.createElement('span');
    packagingFeeTotal.setAttribute('data-northbound-cart-packaging-fee-total', '');

    var taxTotal = document.createElement('span');
    taxTotal.setAttribute('data-northbound-cart-tax-total', '');

    var grandTotal = document.createElement('span');
    grandTotal.setAttribute('data-northbound-cart-grand-total', '');

    appendSummaryRow(snapshot, productsTotal);
    appendSummaryRow(snapshot, shippingTotal);
    appendSummaryRow(snapshot, packagingFeeTotal);
    appendSummaryRow(snapshot, taxTotal);
    appendSummaryRow(snapshot, grandTotal);
  }

  function appendSummaryRow(snapshot, valueNode) {
    var row = document.createElement('div');
    row.appendChild(valueNode);
    snapshot.appendChild(row);
  }

  function removeSnapshotCart() {
    removeSnapshotArtifacts();
    var snapshot = document.querySelector(SNAPSHOT_SELECTOR);
    if (snapshot) snapshot.remove();
  }

  function removeSnapshotArtifacts() {
    Array.from(document.body.children).forEach(function (child) {
      if (
        child.matches('[data-northbound-cart-packaging-fee-row]') ||
        child.matches('[data-northbound-cart-tax-row]')
      ) {
        child.remove();
      }
    });
  }

  function toCents(value) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? Math.round(number) : 0;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
